<template>
  <kw-button-group
    class="kw-pagination"
  >
    <kw-button
      v-if="arrows"
      :disabled="isArrowsDisabled.previous"
      @click="goPrevious"
    >
      <kw-svgicon name="chevron-left" />
    </kw-button>
    <kw-button
      v-for="page in pages"
      :key="page"
      :style-type="getStyleType(page)"
      @click="setPage(page)"
    >
      {{ page }}
    </kw-button>
    <kw-button
      v-if="arrows"
      :disabled="isArrowsDisabled.next"
      @click="goNext"
    >
      <kw-svgicon name="chevron-right" />
    </kw-button>
  </kw-button-group>
</template>

<script>

import KwButton from '@kiwitaxi/vue-components/dist/KwButton';
import KwButtonGroup from '@kiwitaxi/vue-components/dist/KwButtonGroup';
import KwSvgicon from '@kiwitaxi/vue-components/dist/KwSvgicon';

export default {
  name: 'KwPagination',
  components: {
    KwButton,
    KwButtonGroup,
    KwSvgicon,
  },
  props: {
    /**
     * Show/hide navigation arrows
     * @type {boolean}
     * @default true
     */
    arrows: {
      type: Boolean,
      default: true,
    },
    /**
     * Current page (v-model)
     * @type {number}
     * @default 1
     */
    value: {
      type: Number,
      default: 1,
    },
    /**
     * Total pages
     * @type {number}
     */
    totalPages: {
      type: Number,
      default: null,
    },
    /**
     * Pages visible
     * @type {number}
     * @default 5
     */
    pagesVisible: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      cursor: 1,
    };
  },
  computed: {
    isArrowsDisabled() {
      const { value } = this;

      return {
        previous: value <= 1,
        next: value >= this.totalPages,
      };
    },
    pages() {
      const { cursor, totalPages: total } = this;
      const visible = this.pagesVisible;
      const isFromStart = (total - cursor - visible) >= 0;

      return [...Array(visible)]
        .map((item, i) => (isFromStart ? (i + cursor) : ((total - visible) + (i + 1))))
        .filter(page => page > 0);
    },
  },
  watch: {
    value() {
      this.updateCursor();
    },
  },
  created() {
    this.updateCursor();
  },
  methods: {
    setPage(page) {
      this.$emit('input', page);
    },
    goPrevious() {
      this.setPage(Math.max(this.value - 1, 1));
    },
    goNext() {
      this.setPage(Math.min(this.value + 1, this.totalPages));
    },
    getStyleType(page) {
      return page === this.value ? 'success' : undefined;
    },
    updateCursor() {
      const { cursor, value: max } = this;
      const min = max - (this.pages.length + 1);

      if (cursor > max) {
        this.cursor = max;
      }

      if (cursor < min) {
        this.cursor = min;
      }
    },
  },
};
</script>

<style lang="scss">
.kw-pagination {
  .kw-button {
    padding: 0;
    width: rem(48);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UI/KwPagination.vue